module.exports = __webpack_public_path__ + "static/media/speedometer.c0651f39.svg";